export default "__VITE_ASSET__DqY0Uw$R__"